import React from 'react';
import { StyledButton } from './styles';

interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary' | 'outline' | 'outline-dark';
  size?: 'sm' | 'md' | 'lg';
  target?: string;
  rel?: string;
  onClick?: () => void;
  'aria-label'?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  href,
  variant = 'primary',
  size = 'md',
  target = '_blank',
  rel = 'noopener noreferrer',
  onClick,
  ...rest
}) => {
  return (
    <StyledButton
      href={href}
      $variant={variant}
      $size={size}
      target={target}
      rel={rel}
      onClick={onClick}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;

